<template>
    <div class="bannerDetail">
       <div v-html="list.particulars"></div>
    </div>
</template>
<script>
import {bannerDetail } from "@/api/enterprise/index" // 轮播图列表
export default {
    name:'bannerDetail',
    data () {
        return {
            list:{}
        }
    },
    created () {
         document.title = "轮播图详情"
        this.getBanner()
    },
    methods: {
            getBanner(){
              bannerDetail({
                id:this.$route.query.id
            },'enterprise')
            .then(res => {
             this.list = res.data
            })
            .catch(err => {
            })
        },
    }
}
</script>
<style lang="scss">

</style>